import { createGlobalStyle } from 'styled-components'
import * as constants from './constants'

const dateRangePickerCustomStyle = createGlobalStyle`

  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    td {
      width: 24px;
      height: 24px;
    }
    .CalendarDay {
      font-size: 12px;
    }
  }
  .DateRangePicker.DateRangePicker_1 {
    width: 100%;
  }
  .DateRangePickerInput.DateRangePickerInput_1 {
    display: flex;
    align-items: center;
    width: 100%;
    border: solid 1px ${constants.COLORS.divider};
  }
  .DateInput.DateInput_1 {
    width: 50%;
  }
  input#startDate,
  input#endDate {
    &.DateInput_input__focused {
      border-bottom: solid 1px ${constants.COLORS.primary};
    }
  }
  .CalendarDay__highlighted_calendar {
    color: ${constants.COLORS.black};
    background-color: ${constants.COLORS.white};

    &::after {
      content: 'FULL';
      display: block;
      padding: 0;
      color: ${constants.COLORS.white};
      font-size: .6rem;
      font-weight: 800;
      background-color: ${constants.COLORS.primary};
    }

    &:hover {
      color: ${constants.COLORS.black};
      background-color: ${constants.COLORS.white};
      cursor: default;
    }
  }
  .CalendarDay__selected_span:not(.CalendarDay__blocked_out_of_range) {
    background: ${constants.COLORS.secondary};
    border: 1px double ${constants.COLORS.secondary};
    color: ${constants.COLORS.white};
    &.CalendarDay__highlighted_calendar {
      &::after {
        color: ${constants.COLORS.primary};
        background-color: ${constants.COLORS.white};
      }
    }
  }
  .CalendarDay__selected {
    background:  ${constants.COLORS.primary};
    border: 1px double  ${constants.COLORS.primary};
    color: ${constants.COLORS.white};
    &.CalendarDay__highlighted_calendar {
      &::after {
        color: ${constants.COLORS.primary};
        background-color: ${constants.COLORS.white};
      }
    }
  }
  .CalendarDay__selected:hover {
    background:  ${constants.COLORS.primary};
    color: ${constants.COLORS.white};
  }
  .CalendarDay__hovered_span:hover,
  .CalendarDay__hovered_span:not(.CalendarDay__blocked_out_of_range) {
    background: ${constants.COLORS.secondary};
    border: 1px double ${constants.COLORS.secondary};
    color: ${constants.COLORS.white};
  }
`

export default dateRangePickerCustomStyle
